var exports = {
  "vK": "ChannelFollowModal.module__banner___STVoX3",
  "Wp": "ChannelFollowModal.module__patternImage___STVoX3",
  "JE": "ChannelFollowModal.module__bannerRow___STVoX3",
  "QE": "ChannelFollowModal.module__sourceGuildIcon___STVoX3",
  "AQ": "ChannelFollowModal.module__sourceChip___STVoX3",
  "fS": "ChannelFollowModal.module__sourceChipIcon___STVoX3",
  "jl": "ChannelFollowModal.module__sourceChipName___STVoX3",
  "Qs": "ChannelFollowModal.module__content___STVoX3",
  "Lv": "ChannelFollowModal.module__intro___STVoX3",
  "DD": "ChannelFollowModal.module__title___STVoX3",
  "h_": "ChannelFollowModal.module__description___STVoX3",
  "aK": "ChannelFollowModal.module__hint___STVoX3",
  "p$": "ChannelFollowModal.module__emptyState___STVoX3",
  "By": "ChannelFollowModal.module__guildOption___STVoX3",
  "XN": "ChannelFollowModal.module__guildAvatar___STVoX3",
  "oM": "ChannelFollowModal.module__guildAvatarPlaceholder___STVoX3",
  "ed": "ChannelFollowModal.module__optionLabel___STVoX3",
  "TN": "ChannelFollowModal.module__channelOption___STVoX3",
  "p": "ChannelFollowModal.module__channelIcon___STVoX3",
  "yb": "ChannelFollowModal.module__categoryName___STVoX3",
};

module.exports = exports;
